import { makeStyles } from "@material-ui/core"
import cal from "clsx"
import React from "react"

const useStyles = makeStyles({
    statusWrap: {
        width: 80,
        padding: 4,
        borderRadius: 10,
        color: "white",
        textAlign: "center",
        fontWeight: 600,
    },
    draft: {
        backgroundColor: "#f44336",
    },
    finalize: {
        backgroundColor: "#4caf50",
    },
})

interface ComponentProps {
    status: string
}
type Status = "unfilled" | "unfinished" | "finished"
const statusMap = {
    unfilled: "未填写",
    unfinished: "未定稿",
    finished: "定稿",
}
const Status = (props: ComponentProps) => {
    const { status } = props
    const classes = useStyles()
    return (
        <div className={cal(
            classes.statusWrap,
            status === "finished" ? classes.finalize : classes.draft,
        )}>
            {statusMap[status as Status]}
        </div>
    )
}

export default Status
